// Normalise an image URL coming out of the DB to something the browser
// can load. Mirrors the storefront's `imageSrc` helper 1:1 — keep them in
// sync.
//
// Legacy Vīnoga imports stored relative R2 paths like
// `vinoga/uploads/WEB bildes - 2026-05-01T144509.548-…webp` (no protocol,
// no host, and sometimes spaces / unicode). Anything written via the new
// uploader already returns an absolute URL, so we only prefix the legacy
// base when we see a bare path.

const LEGACY_MEDIA_BASE = (
  import.meta.env.VITE_LEGACY_MEDIA_URL ?? ""
).replace(/\/+$/, "");

export function mediaSrc(url: string | null | undefined): string | null {
  if (!url) return null;
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  if (url.startsWith("/")) return url;
  if (!LEGACY_MEDIA_BASE) return null;
  // Encode each path segment so spaces and unicode survive the browser's
  // url parser without becoming `%20%E2%80%A6` mojibake (encodeURI on the
  // whole string would also work but it leaves `?` and `#` alone, which we
  // never use in storage keys).
  const encoded = url
    .replace(/^\/+/, "")
    .split("/")
    .map((seg) => encodeURIComponent(seg))
    .join("/");
  return `${LEGACY_MEDIA_BASE}/${encoded}`;
}
